import React, { useContext, useEffect, useState } from "react";
import Fade from "react-reveal/Fade";
import { Col, Container, Row } from "react-bootstrap";
import PortfolioContext from "../../context/context";

const Infos = () => {
  const { infos } = useContext(PortfolioContext);

  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsMobile(true);
      setIsDesktop(false);
    }
  }, []);

  return (
    <section id="infos">
      <Container>
        <div className="project-wrapper">

          {infos.map((info) => {
            const { techName, url, id, name, content, isEmail } = info;

            return (
              <Row key={id}>
                <Col lg={6} sm={6}>
                  <Fade
                    left={isDesktop}
                    bottom={isMobile}
                    duration={1000}
                    delay={500}
                    distance="30px">
                    <div className="project-wrapper__text">
                      <h3 className="project-wrapper__text-title">{techName}</h3>
                    </div>
                  </Fade>
                </Col>
                <Col lg={6} sm={6}>
                  <Fade
                    right={isDesktop}
                    bottom={isMobile}
                    duration={1000}
                    delay={1000}
                    distance="30px">
                    <div className="project-wrapper__platforms">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        className="project-wrapper__text-title-platform-name"
                        href={isEmail ? "mailto:danynovac@gmail.com" : url}
                      >
                        {name}
                      </a>
                      <p className="project-wrapper__text-title-subtitle">{content}</p>
                    </div>
                  </Fade>
                </Col>
              </Row>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default Infos;
